
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftRight25 as ObiThreewayAnalogInleftRight25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-right-25.js';
 
 
 

 
 export const ObiThreewayAnalogInleftRight25 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-right-25',
   elementClass: ObiThreewayAnalogInleftRight25Element,
   events: {
     
   }
  });
 
 